//Selectors that draw directly from the state tree
import get from 'lodash/get'
import { createSelector } from 'reselect';

export const selectAlertUser = createSelector(
    state => state.alertUser,
    alertUser => alertUser,
);
export const selectDiscover = createSelector(
    state => state.discover,
    discover => discover || [],
);

export const selectEventId = state => {
    return state.location.pathname;
};

export const getFileSelected = state => state.channels.form.file_selected;
export const getImageURL = state => state.channels.form.imageURL;
export const getResetDocumentsToUpload = state => state.ui.resetDocumentsToUpload;
export const selectActiveChannelId = state => state.ui.activeChannel;
export const selectActiveEventId = state => state.ui.activeEvent;
export const selectActiveEfEvent = state => state.events.activeEfEvent;

export const selectActiveMasterEventsFirebase = state => state.events.activeMasterFirebase || {};
export const selectActiveMomentId = state => state.ui.activeMoment;
export const selectActiveNotificationId = state => state.ui.activeNotification;
export const selectActiveDiscoverId = state => state.ui.active_discover_id;
export const selectAuth = state => state.auth;
export const selectChannelEditing = state => state.channels.editing;
export const selectChannels = state => state.channels.channels || {};
export const selectComments = state => (state.moments.all ? state.moments.all.comments : []);
export const selectNotificationsData = state => state.notifications.data || {};
export const selectChannelsForm = state => state.channels.form;
export const selectMessages = state => state.chat.messages;
export const selectMomentFilters = state => state.moments.config.imageFilters || {};
export const selectMoments = state => state.moments;
export const selectMomentsPosts = state => get(state, 'moments.all.posts', null);

export const selectMomentsConfig = state => state.moments.config || {};
export const selectNotifications = state => state.notifications;
export const selectPosts = state => (state.moments.all ? state.moments.all.posts : []);
export const selectRouter = state => state.router;
export const selectSchedule = state => state.schedule || null;
export const selectSessions = state => state.eventwide.sessions || [];
export const selectScheduleDetailsConfig = state => state.schedule.detailsConfig || null;
export const selectScheduleListConfig = state => state.schedule.listConfig || null;
export const selectNotificationsStatus = state => state.notifications.status;
export const selectUserAvatars = state => state.users.avatars;
export const selectUsers = state => get(state, 'users.firebase', []);
export const selectActiveUsersCount = createSelector(
    selectUsers,
    obj => obj ? Object.keys(obj).length : 0,
);

